export const Layer = `
layer {
    layername
    geoType
    type
    layerId
}
`;
